import { IRootState } from 'redux/reducer';

export const selectIsUserCreationModalOpen = (rootState: IRootState): boolean => {
  return rootState.modals.userCreationModal.isOpen;
};

export const selectUserCreationModalEmail = (rootState: IRootState): string => {
  return rootState.modals.userCreationModal.userEmail;
};
